import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';

export function useNotificationPreferences() {
    return useQuery({
        queryKey: ['notification-preferences'],
        queryFn: async () => {
            const response = await axios.get('/api/messaging/preferences/', {
                withCredentials: true,
            });
            return response.data;
        },
        staleTime: 300000, // 5 minutes
    });
}

export function useUpdateNotificationPreferences() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (preferences) => {
            const response = await axios.patch('/api/messaging/preferences/', preferences, {
                withCredentials: true,
            });
            return response.data;
        },
        onSuccess: () => {
            // Invalidate and refetch the preferences
            queryClient.invalidateQueries({ queryKey: ['notification-preferences'] });
        },
    });
} 